// Появление пришедших данных после скелетона: fade 200 мс, без задержки показа.
// При prefers-reduced-motion — сразу, без перехода.
import React from 'react';
import { Fade } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MOTION } from '../../styles/tokens';

export function usePrefersReducedMotion() {
  return useMediaQuery('(prefers-reduced-motion: reduce)', { noSsr: true });
}

export default function FadeIn({ children, timeout = MOTION.contentIn }) {
  const reduced = usePrefersReducedMotion();
  return (
    <Fade in appear timeout={reduced ? 0 : timeout}>
      {children}
    </Fade>
  );
}
